export class RadiologyResultDataModel {
    image: string;
    TestName: string;
    RequestDate: string;
    RequestTime: string; 
    SessionTimeout: string;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/radiology/radiologyresultsdatamodel.ts